import Support from "../component/Support/Support";


function SupportPage(props) {
  return (
    <div>
      <Support />
    </div>
  );
}

export default SupportPage;
